import PropTypes from 'prop-types'

import { joinFilterValuesByProp } from 'utils/filters/utils'
import { getDisplayName, getUrlParam } from 'utils/mixpanel'

import { orderFilters } from './filters'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location, profileName, accountId } = props

    const getApplyFiltersParameters = () => {
      const { selectedFilters } = props

      const {
        createdDateRange: { filterKey: createDateKey },
        deliveryCompleteDateRange: { filterKey: completeDateKey },
        deliveryStartDateRange: { filterKey: startDateKey },
        modifiedDateRange: { filterKey: modifyDateKey },
        salesRepresentatives: { filterKey: saleRepresentativeKey },
        collections: { filterKey: collectionKey },
        types: { filterKey: typeKey },
        exportStatusSuccess: { filterKey: exportStatusKey },
        orderEvents: { filterKey: eventKey },
        divisions: { filterKey: divisionsKey },
        createdByRetailer: { filterKey: createdByRetailerKey },
      } = orderFilters

      const createDate = `${createDateKey}: ${
        selectedFilters[createDateKey]
          ? selectedFilters[createDateKey].startDate
          : ''
      }`
      const completeDate = `${completeDateKey}: ${
        selectedFilters[completeDateKey]
          ? selectedFilters[completeDateKey].startDate
          : ''
      }`
      const startDate = `${startDateKey}:  ${
        selectedFilters[startDateKey]
          ? selectedFilters[startDateKey].startDate
          : ''
      }`
      const modifyDate = `${modifyDateKey}: ${
        selectedFilters[modifyDateKey]
          ? selectedFilters[modifyDateKey].startDate
          : ''
      }`
      const dateFilter = `${createDate}, ${completeDate}, ${startDate}, ${modifyDate}`

      const exportStatusFilter = Object.entries(
        selectedFilters[exportStatusKey] || {},
      )
        .map(([status, filterValue]) => {
          if (Array.isArray(filterValue)) {
            return `${status}: ${joinFilterValuesByProp(filterValue)}`
          }
          return `${status}: ${filterValue}`
        })
        .join('; ')

      return {
        'Sales Rep Filter': joinFilterValuesByProp(
          selectedFilters[saleRepresentativeKey],
        ),
        'Linesheet Filter': joinFilterValuesByProp(
          selectedFilters[collectionKey],
        ),
        'Date Filter': dateFilter,
        'Type Filter': joinFilterValuesByProp(selectedFilters[typeKey]),
        'Export Status Filter': exportStatusFilter,
        'Event Filter': joinFilterValuesByProp(selectedFilters[eventKey]),
        'Division Code Filter': joinFilterValuesByProp(
          selectedFilters[divisionsKey],
        ),
        'Created by Retailers Filter': selectedFilters[createdByRetailerKey],
        ...getUrlParam(location),
      }
    }

    const trackers = {
      trackApplyFilters: () =>
        mixpanel.track(
          'Orders List_Filter Applied',
          getApplyFiltersParameters(),
        ),
      trackApplySearch: ({ searchText }) =>
        mixpanel.track('Orders List_Search', {
          'Search query': searchText,
          ...getUrlParam(location),
        }),
      trackExpandFilters: () => mixpanel.track('Orders List_Expand Filters'),
      trackCloseFilters: () => mixpanel.track('Orders List_Close Filters'),
      trackClearAllFilters: () =>
        mixpanel.track('Orders List_Clear All Filters', {
          User: accountId,
          Brand: profileName,
        }),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
